import service from '@/services/superaccess'

const reception = {
  state: {
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    retrieveDataFormReport (context) {
      return service.post('/api/reports/new', context, context.getters.getUserShard)
    },
    getGenerateReport (context, payload) {
      switch (payload.report_type) {
        case 1:
          return service.download(`/api/reports/present_personal/${payload.report_type}/${payload.company_ids}/${payload.auth_types_ids}`, context)
        case 2:
          return service.download(`/api/reports/authorized_people/${payload.report_type}/${payload.company_ids}/${payload.person_type}/${payload.show_blockade}/${payload.start_date}/${payload.end_date}/${payload.autho_state}/${payload.auth_types_ids}`, context)
        case 3:
          return service.download(`/api/reports/staff_about_to_expire/${payload.report_type}/${payload.company_ids}`, context)
        case 4:
          return service.download(`/api/reports/historical-access/${payload.report_type}/${payload.company_ids}/${payload.department}/${payload.control_point}/${payload.identification_number}/${payload.start_date}/${payload.end_date}`, context)
        case 5:
          return service.download(`/api/reports/exceptions/${payload.report_type}/${payload.id_person}/${payload.movement_all}/${payload.exception_type}/${payload.start_date}/${payload.end_date}`, context)
        case 6:
          return service.download(`/api/reports/assists/${payload.report_type}/${payload.company_ids}/${payload.start_date}/${payload.end_date}`, context)
        case 7:
          return service.download(`/api/reports/authorized_by_person/${payload.report_type}/${payload.person_type}/${payload.identification_number}`, context)
        case 8:
          return service.download(`/api/reports/use-of-the-system/${payload.report_type}/${payload.company_ids}/${payload.start_date}/${payload.end_date}/${payload.property}`, context)
        case 9:
          return service.download(`/api/reports/public_vehicles/${payload.report_type}/${payload.id_person}/${payload.start_date}/${payload.end_date}`, context)
        case 10:
          return service.download(`/api/reports/forced_access/${payload.report_type}/${payload.id_person}/${payload.start_date}/${payload.end_date}`, context)
        case 15:
          return service.download(`/api/reports/system_charges/${payload.report_type}/${payload.start_date}/${payload.end_date}/${payload.payment_state}/${payload.property}`, context)
        // case 16:
        //   return service.download(`/api/reports/minute_report/${payload.report_type}/${payload.start_date}/${payload.end_date}/${payload.user_id}`, context)
        // case 17:
        //   return service.download(`/api/reports/minute_report/${payload.report_type}/${payload.start_date}/${payload.end_date}/${payload.user_id}`, context)
        default:
          return service.download(`/api/reports/generate-report/${payload.report_type}/${payload.company_ids}/${payload.show_blockade}`, context)
      }
    },
    getReportByProfile (context, payload) {
      return service.post('/api/reports/profile', context, { profile_id: payload.profile_id })
    }
  }
}

export default reception



// WEBPACK FOOTER //
// app/javascript/src/store/report.js